t = require('views/internal/teacup-with-helpers')('label')

module.exports = t.renderable ({ color, name, extraClasses }) ->
  classes =
    'card-label': true

  if color
    classes["card-label-#{ color }"] = true

  if extraClasses
    for c in extraClasses
      classes[c] = true

  t.span { class: t.classify(classes), title: name ? "#{ color } label (default)" }, ->
    if name
      t.text name
    else
      t.raw '&nbsp;'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/label.coffee